  import { useState, useEffect } from 'react';
  import { Link, useParams } from 'react-router-dom';
  import styles from './BooksDatails.module.css';
  import axios from 'axios';

  import NotFound from '../NotFound';
  import Loading from '../../components/Loading';

  export default function BooksDetails() {
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
      axios.get(`https://back-cultura-sje-production.up.railway.app/get-book/${id}`, {})
        .then((response) => {
          setBook(response.data)})
        .catch((error) => {
          console.error('Erro ao buscar livro', error);
        })
        .finally(() => {
          setTimeout(() => setLoading(false), 500);
        });
    }, [id]);

    if (loading) {
      return (
        <div className={styles.container}>
          <Loading />
        </div>
      );
    }

    if (!book) {
      return (
        <div className={styles.container}>
          <NotFound />
        </div>
      );
    }

    return (
      <main className={styles.page}>
        <div className={styles.container}>
          <div className={styles.bookDetails}>
            <div className={styles.coverSection}>
              <img 
                src={book.capa} 
                alt={book.titulo}
                className={styles.bookCover}
              />
            </div>

            <div className={styles.infoSection}>
              <h1 className={styles.title}>{book.titulo}</h1>
              
              <div className={styles.bookInfo}>
                <span className={styles.genre}>
                  <strong>Gênero:</strong> {book.genero}
                </span>
                <span className={styles.year}>
                  <strong>Ano de Lançamento:</strong> {book.anoLancamento}
                </span>
                <span className={styles.price}>
                  <strong>Preço:</strong> R$ {book.preco.toFixed(2)}
                </span>

                {book.autor.telefone && book.tipo_venda === 'whatsapp_autor' &&
                  <span className={styles.link}>
                    <a href={`https://wa.me/55${book.autor.telefone}`}><strong>Comprar livro com o autor</strong></a>
                  </span>
                }

                {book.tipo_venda === 'whatsapp_sebo' &&
                  <span className={styles.link}>
                    <a href='https://wa.me/5587999563697'><strong>Comprar livro no sebo cultural</strong></a>
                  </span>
                }

                {book.tipo_venda === 'esgotado' &&
                  <p className={styles.esgotado}>❌ ESGOTADO</p>
                }
              </div>

              <div className={styles.synopsis}>
                <h3 className={styles.synopsisTitle}>Sinopse</h3>
                <p className={styles.synopsisText}>{book.sinopse}</p>
              </div>
            </div>
          </div>

          <Link to={`/autores/${book.autor.id}`}>
            <div className={styles.cardAuthor}>
              <div className={styles.authorHeader}>
                <img 
                  src={book.autor.foto} 
                  alt={book.autor.nomeArtistico}
                  className={styles.authorAvatar}
                />
                <div className={styles.authorInfo}>
                  <h3 className={styles.authorName}>{book.autor.nomeArtistico}</h3>
                  <span className={styles.authorLabel}>Autor</span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </main>
    );
  }